import type { SVGProps } from 'react';
const DawnFlagKZ = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-KZ_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-KZ_svg__a)">
      <path fill="#30C6E0" d="M0 0h22v16H0z" />
      <path
        fill="#FFCD4B"
        fillRule="evenodd"
        d="M11 11.2c1.736 0 3.143-1.433 3.143-3.2S12.736 4.8 11 4.8 7.857 6.233 7.857 8 9.265 11.2 11 11.2"
        clipRule="evenodd"
      />
      <path
        fill="#FFCD4B"
        fillRule="evenodd"
        d="M9.718 13.72 11 11.77l1.282 1.949.325-2.322 1.986 1.189-.697-2.236 2.296.194L14.61 8.84 16.762 8l-2.151-.839 1.58-1.706-2.295.194.697-2.236-1.986 1.19-.325-2.322L11 4.229 9.718 2.281l-.325 2.322-1.985-1.19.697 2.236-2.296-.194 1.58 1.706-2.15.84 2.15.838-1.58 1.707 2.296-.195-.697 2.236 1.985-1.19zM14.667 8c0 2.062-1.642 3.733-3.667 3.733S7.334 10.062 7.334 8 8.975 4.267 11 4.267 14.667 5.938 14.667 8M1.048 1.4c0-.184.15-.333.333-.333h.381c.184 0 .333.149.333.333v.4c0 .184-.149.333-.333.333h-.38a.333.333 0 0 1-.334-.333zm0 2.133c0-.184.15-.333.333-.333h.381c.184 0 .333.15.333.333v.4c0 .184-.149.334-.333.334h-.38a.333.333 0 0 1-.334-.334zm.333 1.8a.333.333 0 0 0-.333.334v.4c0 .184.15.333.333.333h.381c.184 0 .333-.15.333-.333v-.4a.333.333 0 0 0-.333-.334zM1.048 7.8c0-.184.15-.333.333-.333h.381c.184 0 .333.149.333.333v.4c0 .184-.149.333-.333.333h-.38a.333.333 0 0 1-.334-.333zm.333 1.8a.333.333 0 0 0-.333.333v.4c0 .184.15.334.333.334h.381c.184 0 .333-.15.333-.334v-.4a.333.333 0 0 0-.333-.333zm-.333 2.467c0-.184.15-.334.333-.334h.381c.184 0 .333.15.333.334v.4c0 .184-.149.333-.333.333h-.38a.333.333 0 0 1-.334-.333zm.333 1.8a.333.333 0 0 0-.333.333v.4c0 .184.15.333.333.333h.381c.184 0 .333-.149.333-.333v-.4a.333.333 0 0 0-.333-.333zm.714-.734c0-.184.15-.333.334-.333h.38c.185 0 .334.15.334.333v.4c0 .184-.15.334-.333.334h-.381a.333.333 0 0 1-.334-.334zm.334-2.466a.333.333 0 0 0-.334.333v.4c0 .184.15.333.334.333h.38c.185 0 .334-.149.334-.333V11a.333.333 0 0 0-.333-.333zm-.334-1.8c0-.184.15-.334.334-.334h.38c.185 0 .334.15.334.334v.4c0 .184-.15.333-.333.333h-.381a.333.333 0 0 1-.334-.333zM2.43 6.4a.333.333 0 0 0-.334.333v.4c0 .184.15.334.334.334h.38c.185 0 .334-.15.334-.334v-.4A.333.333 0 0 0 2.81 6.4zm-.334-1.8c0-.184.15-.333.334-.333h.38c.185 0 .334.149.334.333V5c0 .184-.15.333-.333.333h-.381A.333.333 0 0 1 2.095 5zm.334-2.467a.333.333 0 0 0-.334.334v.4c0 .184.15.333.334.333h.38c.185 0 .334-.15.334-.333v-.4a.333.333 0 0 0-.333-.334z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagKZ;
